import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Register from './pages/Register';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import NewRequest from './pages/NewRequest';
import RequestHistory from './pages/RequestHistory';
import RedeemPoints from './pages/RedeemPoints';
import RedemptionHistory from './pages/RedemptionHistory';
import PetTracking from './pages/PetTracking';
import MaterialRequest from './pages/MaterialRequest';
import MaterialHistory from './pages/MaterialHistory';
import Profile from './pages/Profile';
import Feedback from './pages/Feedback';
import PriceGuide from './pages/PriceGuide';
import AdminLogin from './pages/AdminLogin';
import AdminPanel from './pages/AdminPanel';
import { Toaster } from './components/ui/sonner';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/requests/new" element={<NewRequest />} />
          <Route path="/requests/history" element={<RequestHistory />} />
          <Route path="/redeem-points" element={<RedeemPoints />} />
          <Route path="/redemption-history" element={<RedemptionHistory />} />
          <Route path="/pet-tracking" element={<PetTracking />} />
          <Route path="/material-request" element={<MaterialRequest />} />
          <Route path="/material-history" element={<MaterialHistory />} />
          <Route path="/feedback" element={<Feedback />} />
          <Route path="/price-guide" element={<PriceGuide />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPanel />} />
          <Route path="/" element={<Navigate to="/login" replace />} />
        </Routes>
        <Toaster />
      </div>
    </Router>
  );
}

export default App;
